import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import useUserStore from "../../../utils/storeApp";

const RegistrationOrgSuccess = () => {
  const navigate = useNavigate();
  const [createUser, setCreateUser] = useState(false);

  const { userSession, userRole } = useUserStore((state) => ({
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    userRole: state.userRole,
  }));

  useEffect(() => {
    setCreateUser(
      userSession?.CreateUserFlag ||
        userRole === "SES ADMINISTRATOR" ||
        userRole === "SYSTEMADMINISTRATOR"
    );
  }, [userSession, userRole]);

  return (
    <Layout>
      <HeaderOrg />
      <main className="layout-container">
        <div className="container ctr">
          <div className="bi-success-check" aria-hidden="true">
            <i
              className="bi bi-check2-circle"
              aria-hidden="true"
            ></i>
          </div>

         <h1 
            className="lg-msg"
            role="status"
            aria-live="polite"
          >
                Organization has been added successfully.
         </h1>

          {createUser ||
          userRole === "SES ADMINISTRATOR" ||
          userRole === "SYSTEMADMINISTRATOR" ? (
            <div>
              <div className="text-size6 spacer-margin3">
                You may now add users to this organization.
              </div>
              <Link
                to="/user-registration"
                className="btn btn-primary"
              >
                Add Users
              </Link>
            </div>
          ) : null}
        </div>
      </main>
    </Layout>
  );
};

export default RegistrationOrgSuccess;
